module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1609970004001"
    }
  }), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A DAVID & CHARLES BOOK")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © David & Charles Limited 2008")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("David & Charles is an F+W Publications Inc. company "), _c('br'), _vm._v("4700 East Galbraith Road "), _c('br'), _vm._v("Cincinnati, OH 45236")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First published in the UK in 2008")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Text and designs copyright © Sally Southern 2008 "), _c('br'), _vm._v("Photography copyright © David & Charles 2008")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Sally Southern has asserted her right to be identified as author of this work in "), _c('br'), _vm._v("accordance with the Copyright, Designs and Patents Act, 1988.")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored "), _c('br'), _vm._v("in a retrieval system, or transmitted, in any form or by any means, electronic "), _c('br'), _vm._v("or mechanical, by photocopying, recording or otherwise, without prior "), _c('br'), _vm._v("permission in writing from the publisher.")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The designs in this book are copyright and must not be stitched for resale.")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The author and publisher have made every effort to ensure that all the "), _c('br'), _vm._v("instructions in the book are accurate and safe, and therefore cannot accept "), _c('br'), _vm._v("liability for any resulting injury, damage or loss to persons or property, "), _c('br'), _vm._v("however it may arise.")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Names of manufacturers, fabric ranges and other products are "), _c('br'), _vm._v("provided for the information of readers, with no intention to infringe "), _c('br'), _vm._v("copyright or trademarks.")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A catalogue record for this book is available from the British Library.")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN-13: 978-0-7153-2649-7  paperback")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN-10: 0-7153-2649-X  paperback")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed in China by SNP Leefung Pte Ltd "), _c('br'), _vm._v("for David & Charles")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Brunel House Newton Abbot Devon")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Commissioning Editor  Jennifer Fox-Proverbs "), _c('br'), _vm._v("Desk Editor Bethany Dymond "), _c('br'), _vm._v("Senior Designer Charly Bailey "), _c('br'), _vm._v("Project Editor Natasha Reed "), _c('br'), _vm._v("Production Controller Bev Richardson "), _c('br'), _vm._v("Photographers Kim Sayer and Karl Adamson")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Visit our website at "), _c('a', {
    attrs: {
      "href": "http://www.davidandcharles.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.davidandcharles.co.uk")])]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("David & Charles books are available from all good bookshops; alternatively "), _c('br'), _vm._v("you can contact our Orderline on 0870 9908222 or write to us at FREEPOST "), _c('br'), _vm._v("EX2 110, D&C Direct, Newton Abbot, TQ12 4ZZ (no stamp required UK only); US customers call 800-289-0963 and Canadian customers call 800-840-5220.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c180f2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch003.vue
// module id = 63
// module chunks = 0